import { useAuthentication } from '@/composables/useAuthentication';

const USER_DEFINED_INDEX_REGULAR_EXPRESSION = /@[a-z0-9]+/i;
const USER_DEFINED_INDEX_WITH_CHART_CODE_REGULAR_EXPRESSION = /@[a-z0-9]+-[0-9]+/i;
const USER_DEFINED_INDEX_WITH_CHART_CODE_GLOBAL_REGULAR_EXPRESSION = /@[a-z0-9]+-[0-9]+/gi;

function appendChartCodeToUserDefinedIndexSymbol(symbol: string) {
  const { isLoggedIn, chartCode } = useAuthentication();

  if (
    !symbol ||
    USER_DEFINED_INDEX_WITH_CHART_CODE_REGULAR_EXPRESSION.test(symbol) ||
    !isLoggedIn.value
  ) {
    return symbol;
  }

  return symbol.replace(USER_DEFINED_INDEX_REGULAR_EXPRESSION, match => `${match}-${chartCode.value}`);
}

function removeChartCodeFromUserDefinedIndexSymbol(symbol: string) {
  const { isLoggedIn } = useAuthentication();

  if (
    !symbol ||
    !isLoggedIn.value
  ) {
    return symbol;
  }

  return symbol.replace(USER_DEFINED_INDEX_WITH_CHART_CODE_GLOBAL_REGULAR_EXPRESSION, match => match.split('-')[0]);
}

export function useUserDefinedIndexes() {
  return {
    appendChartCodeToUserDefinedIndexSymbol,
    removeChartCodeFromUserDefinedIndexSymbol
  };
}
